import { useTranslation } from 'next-i18next'
import { useCallback } from 'react'
import { localeNamespace } from './i18n/Locale'
import { balerSubtypeTranslationMapping } from './i18n/translationMappings'
import { SubTypes } from './MachineType'

export const useMachineSubTypeName = () => {
  const { t } = useTranslation(localeNamespace.common)

  const getMachineSubTypeName = useCallback(
    (machineSubType: SubTypes[keyof SubTypes], count: number = 0) => {
      return t(balerSubtypeTranslationMapping[machineSubType], {
        count,
      }) as SubTypes[keyof SubTypes]
    },
    [t]
  )

  return { getMachineSubTypeName }
}
